module.exports = __webpack_public_path__ + "static/media/promo-dots.7b4e18c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/promocode/promo-dots.svg
// module id = 1628
// module chunks = 103